/* eslint-disable max-len */
import modelData from '../modelData.json'

// THIS VERSION OF THE FUNCTION IS NOT USED - YOU ARE IN THE STANDALONE DIRECTORY

export const getCustomModels = (activeModelIds, orgId) => async (dispatch) => {
  const result = {}
  for (let model_id of activeModelIds) {
    const lookupId = model_id.replace('_new_model', '')
    let entry = modelData.customModels[lookupId]
    if (!entry && model_id.includes('_new_model')) {
      const rikai2 = modelData.customModels['Rikai2']
      if (rikai2) {
        entry = JSON.parse(JSON.stringify(rikai2))
        entry.public.metadata.name = lookupId
      }
    }
    if (entry && !entry.public?.isDeprecated) {
      result[lookupId] = { public: entry.public }
    }
  }
  return result
}
